export enum OrganisationType {
    Standard = "Standard",
    Sandbox = "Sandbox",
    Template = "Template",
}

export enum SubscriptionStatus {
    Active = "Active",
    Inactive = "Inactive",
    Trial = "Trial",
    PendingInactive = "PendingInactive",
}

export enum SubscriptionSubStatus {
    None = "None",
    TrialEnded = "TrialEnded",
    TrialExtended = "TrialExtended",
    SubscriptionCancelled = "SubscriptionCancelled",
    SubscriptionResumed = "SubscriptionResumed",
    NonPayment = "NonPayment",
}

export enum PaymentMethod {
    CreditCard = "CreditCard",
    Invoice = "Invoice",
}
